var favoriteListController = function($http, $window, personalService, $rootScope,
    userProfileManager, configManager, strings, AccountConfigManager) {
    var self = {};
    var accountConfigManager = AccountConfigManager.getConfig(configManager);
    var countryCode = accountConfigManager.site['countryCode'];
    var sapServiceEndPoint = accountConfigManager.site['legacyServer'];
    var language = accountConfigManager['languageCode'];
    var userProfileInfo = userProfileManager.getUserProfileMasterInfo();
    var userType = userProfileInfo.userType;

    self.strings = {
        successMsg: strings.get('tdc_addToBagSuccessMsg'),
        failureMsg: strings.get('tdc_addToBagFailureMsg'),
        viewCartText: strings.get('tdc_viewCartLabel'),
        cartUrl: strings.get('tdc_viewCartUrl'),
        psvLabel: strings.get('tdc_psvLabel'),
        addToBagLabel: strings.get('tdc_addToBagBtn'),
        deleteFromFavoritesLabel: strings.get('tdc_deleteBtn'),
        noItemInFavoritesMsg: strings.get('tdc_noFavoritesMsg')
    };

    self.init = function() {
        // favorite list processing
        if (aem.shop.getFavoritesCookie() && aem.shop.getFavoritesCookie() !== null &&
            aem.shop.getFavoritesCookie().length > 0) {
            var favoriteList = aem.shop.getFavoritesCookie();
            self.favoriteList = self.retrieveDetailedItemInformation(favoriteList);
            self.showNoFavItemsMessage = false;
        } else {
            personalService.retrieveFavoriteList().then(function(res) {
                if (res.data.FavoriteResponseList && res.data.FavoriteResponseList.length > 0) {
                    self.favoriteList = self.retrieveDetailedItemInformation(res.data.FavoriteResponseList);
                    if (typeof aem !== 'undefined' && aem.hasOwnProperty('shop')) {
                        aem.shop.setFavoritesCookie(res.data.FavoriteResponseList);
                    }
                } else {
                    self.favoriteList = [];
                    self.showNoFavItemsMessage = true;
                }
            });
        }
    };

    self.isItemAvailable = function(item) {
        return item.market.statusCode !== '5';
    };

    self.processItemInformation = function(item) {
        var itemObject = {};
        itemObject.sku = item.sku;
        // The price is retail for retail customers and wholesale for other types
        if (userProfileManager.isUserRetailCustomer(userType)) {
            itemObject.price = item['populateRetailPricing']['retailPriceValue'];
        } else {
            itemObject.price = item['populateWholesalePricing']['wholeSalePriceValue'];
        }
        // PSV is displayed for distributors and associates
        if (userProfileManager.isUserDistributor(userType) || userProfileManager.isUserRetailerDistributor(userType)
            || userProfileManager.isUserAssociate(userType)) {
            itemObject.psv = item['populateWholesalePricing']['psvValue'];
        } else {
            itemObject.psv = '';
        }

        itemObject.productTitle = item.description;
        itemObject.image = sapServiceEndPoint + item.contents['fullImage'];

        itemObject.isProductPurchasable = self.isItemAvailable(item);

        return itemObject;
    };

    self.retrieveItemInformation = function(sku) {
        var productLookupURL = sapServiceEndPoint + '/content/products/' + sku.substring(0, 2) + '/' +
            sku.substring(2, 4) + '/' + sku.substring(4, 6) + '/' + sku + '/' + language.toLowerCase() +
            '.service.' + countryCode.toUpperCase() + '.json';
        return $http.get(productLookupURL);
    };

    self.retrieveDetailedItemInformation = function(list) {
        var favorites = [];
        // find the product's information
        for (var i = 0; i < list.length; i++) {
            var sku = list[i].sku;
            self.retrieveItemInformation(sku).then(function(res) {
                if (res.data.sku) {
                    var newItem = self.processItemInformation(res.data);
                    favorites.push(newItem);
                }
            });
        }
        return favorites;
    };

    self.deleteItemFromFavorites = function(sku) {
        personalService.deleteFromFavoritesList(sku).then(function() {
            if (typeof aem !== 'undefined' && aem.hasOwnProperty('shop')) {
                var favoritesCookie = aem.shop.getFavoritesCookie();
                if (favoritesCookie && favoritesCookie.length > 0) {
                    for (var i = 0; i < favoritesCookie.length; i++) {
                        if (favoritesCookie[i].sku === sku) {
                            favoritesCookie.splice(i, 1);
                        }
                    }
                }
                aem.shop.setFavoritesCookie(favoritesCookie);
            }
            self.favoriteList.forEach(function(item, index) {
                if (item.sku === sku) {
                    self.favoriteList.splice(index, 1);
                }
            });
            if (self.favoriteList.length === 0) {
                self.showNoFavItemsMessage = true;
            } else {
                self.showNoFavItemsMessage = false;
            }
        }).catch(function(err) {
            console.log('delete from favorites list err: ' + err);
        });
    };

    self.addFavoriteItemToCart = function(sku, name) {
        if (typeof aem !== 'undefined' && aem.hasOwnProperty('shop')) {
            aem.newShop.orderDetail = aem.newShop.orderDetail || {};
            aem.newShop.orderDetail.sku = sku;
            aem.shop.addToCart(sku, 1);
            var messages = {};
            if (self.strings.cartUrl === '? tdc_viewCartUrl' || self.strings.viewCartText === '? tdc_viewCartText') {
                messages = {
                    successMessage: name + ' ' + self.strings.successMsg
                };
            } else {
                messages = {
                    successMessage: name + ' ' + self.strings.successMsg,
                    successUrl: self.strings.cartUrl,
                    successUrlText: self.strings.viewCartText
                };
            }
            $rootScope.$emit('addToBagSuccessMsg', messages);
        } else {
            $rootScope.$emit('addToBagFailureMsg', self.strings.failureMsg);
        }
    };
    return self;
};

export default favoriteListController;




//////////////////
// WEBPACK FOOTER
// ./angular/components/favorite-list/favorite-list.js
// module id = 369
// module chunks = 0